<div class="container py-4 py-md-5">

  <div class="row">
    <div class="col-md-12" *ngFor="let item of items">
      <app-item-lista [item]="item" ></app-item-lista>
    </div>
  </div>

</div>